<template>
<div>New Group</div>
</template>

<script>
export default {
  name: 'PersonNewReservationGroup',
}
</script>

<style scoped>

</style>
